import { gql } from '@apollo/client';

export const REUSE_RULE_FIELDS = gql`
  fragment reuseRuleFields on ReuseRule {
    __typename
    id
    primaryClickDelay
    primaryConversionDelay
    primaryMaxUses
    primaryOpenDelay
    primarySendDelay
    otherClickDelay
    otherConversionDelay
    otherMaxUses
    otherOpenDelay
    otherSendDelay
  }
`;

export const GET_CREATIVE_REUSE_RULE = gql`
  ${REUSE_RULE_FIELDS}
  query GetCreativeReuseRule($creativeId: ID!) {
    creative(id: $creativeId) {
      __typename
      id
      disableReuseRules
      reuseRule {
        ...reuseRuleFields
      }
    }
  }
`;

export const CREATIVE_DISABLE_REUSE_RULES_UPDATE = gql`
  mutation creativeDisableReuseRulesUpdate(
    $creativeId: ID!
    $disableReuseRules: Boolean!
  ) {
    creativeDisableReuseRulesUpdate(
      creativeId: $creativeId
      disableReuseRules: $disableReuseRules
    ) {
      __typename
      ... on CreativeSuccess {
        __typename
        success
        creative {
          __typename
          id
          disableReuseRules
        }
      }
    }
  }
`;

export const CREATIVE_REUSE_RULE_UPDATE = gql`
  ${REUSE_RULE_FIELDS}
  mutation creativeReuseRuleUpdate(
    $creativeId: ID!
    $reuseRule: ReuseRuleInput!
  ) {
    creativeReuseRuleUpdate(creativeId: $creativeId, reuseRule: $reuseRule) {
      __typename
      ... on CreativeReuseRuleUpdate {
        __typename
        reuseRule {
          ...reuseRuleFields
        }
      }
    }
  }
`;
